import styled, { css } from "styled-components";
const Container = styled.div<{ inverted?: boolean }>`
  flex-direction: row;
  gap: 15px;
  text-transform: uppercase;
  align-items: center;
  justify-items: center;
  display: flex;

  font-family: "Open Sans Condensed";

  font-weight: 300;
  letter-spacing: 26%;
  font-size: 30px;

  color: ${({ inverted }) => (inverted ? "#142425" : "#a2a087")};

  letter-spacing: 0.26em;
`;
const Decoration = styled.div<{ inverted?: boolean }>`
  background-image: ${({ inverted }) =>
    inverted ? 'url("/kum/singInv.webp")' : 'url("/kum/sign.webp")'};
  width: 20px;
  height: 5px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`;
export function FancyTitle(props: {
  text: string;
  double?: boolean;
  inverted?: boolean;
}) {
  return (
    <Container inverted={props.inverted}>
      <Decoration inverted={props.inverted} />
      <div>{props.text}</div>
      {props.double && <Decoration inverted={props.inverted} />}
    </Container>
  );
}
